import { gql } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router-dom';
import { ControlLink } from '@moda/om';
import { titleize } from '@moda/portal-stanchions';
import { hrefFor } from '../../routers/PageRoutes';
import { ProductShopLinksFragment } from '../../generated/types';

import './ProductShopLinks.scss';

export const PRODUCT_SHOP_LINKS_FRAGMENT = gql`
  fragment ProductShopLinksFragment on Variant {
    category
    designerName: designer_name
    designerSlug: designer_slug
    gender
    subcategory
  }
`;

type ProductShopLinksParams = {
  vertical: string;
};

type ProductShopLinksProps = {
  variant: ProductShopLinksFragment;
};

export const ProductShopLinks: React.FC<ProductShopLinksProps> = ({ variant }) => {
  const match = useParams<ProductShopLinksParams>();

  const productCategory = variant.category[0]?.replace(/[_\s]/g, '-').toLowerCase();
  const productSubcategory = variant.subcategory[0]?.replace(/[_\s]/g, '-').toLowerCase();

  return (
    <div className="ProductShopLinks">
      {variant.designerSlug && (
        <ControlLink
          className="ProductShopLinks__link"
          to={hrefFor.DesignerPage({
            designerSlug: variant.designerSlug,
            vertical: match.vertical
          })}
        >
          {`All ${variant.designerName}`}
        </ControlLink>
      )}

      {variant.subcategory.map(
        subcategory =>
          variant?.category[0] &&
          subcategory && (
            <ControlLink
              className="ProductShopLinks__link"
              key={subcategory}
              to={hrefFor.ProductCategoryListingPage({
                category: productCategory as string,
                subcategory: productSubcategory as string,
                vertical: match.vertical
              })}
            >
              {titleize(`All ${subcategory}`)}
            </ControlLink>
          )
      )}
    </div>
  );
};
